// JOBS

export const selectJob = (state, id) => state.dispatch.jobs[id];

export const selectTeamJobs = (state, ids) => {
  const teamJobs = [];

  try {
    ids.forEach((id) => {
      teamJobs.push(state.dispatch.teamJobs[id]);
    });
  } catch (e) {
    console.log(e);
  }
  return teamJobs;
};

export const selectAllJobs = (state) => {
  const jobs = [];

  try {
    Object.keys(state.dispatch.jobs).forEach((key) => {
      jobs.push(state.dispatch.jobs[key]);
    });
  } catch (e) {
    console.log(e);
  }
  return jobs;
};

// TRUCKS

export const selectTruck = (state, id) => {
  try {
    return state.dispatch.trucks[id];
  } catch (e) {
    console.log(e);
  }
};

export const selectTeamTrucks = (state, ids) => {
  const teamTrucks = [];

  try {
    ids.forEach((id) => {
      teamTrucks.push(state.dispatch.trucks[id]);
    });
  } catch (e) {
    console.log(e);
  }
  return teamTrucks;
};

export const selectAllTrucks = (state) => {
  const trucks = [];

  try {
    Object.keys(state.dispatch.trucks).forEach((key) => {
      trucks.push(state.dispatch.trucks[key]);
    });
  } catch (e) {
    console.log(e);
  }
  return trucks;
};

export const selectAllOccupiedTrucks = (state) => {
  let trucks = [];

  try {
    Object.keys(state.dispatch.teams).forEach((key) => {
      trucks = trucks.concat(state.dispatch.teams[key].trucks);
    });
  } catch (e) {
    console.log(e);
  }
  return trucks;
};

// EMPLOYEES

export const selectEmployee = (state, id) => {
  try {
    return state.dispatch.employees[id];
  } catch (e) {
    console.log(e);
  }
};

export const selectTeamEmployees = (state, ids) => {
  const teamEmployees = [];

  try {
    ids.forEach((id) => {
      teamEmployees.push(state.dispatch.employees[id]);
    });
  } catch (e) {
    console.log(e);
  }
  return teamEmployees;
};

export const selectAllEmployees = (state) => {
  const employees = [];

  try {
    Object.keys(state.dispatch.employees).forEach((key) => {
      const employee = state.dispatch.employees[key];
      if (!employee.deleted && employee.available) {
        employees.push(employee);
      }
    });
  } catch (e) {
    console.log(e);
  }
  return employees;
};

export const selectAllOccupiedEmployees = (state) => {
  let employees = [];

  try {
    Object.keys(state.dispatch.teams).forEach((key) => {
      employees = employees.concat(state.dispatch.teams[key].employees);
    });
  } catch (e) {
    console.log(e);
  }
  return employees;
};

export const selectAllOccupiedCaptains = (state) => {
  const captains = [];

  try {
    Object.keys(state.dispatch.teams).forEach((key) => {
      captains.push(state.dispatch.teams[key].captain_id);
    });
  } catch (e) {
    console.log(e);
  }
  return captains;
};

// TOOLBOXES

export const selectToolbox = (state, id) => {
  try {
    return state.dispatch.toolboxes[id];
  } catch (e) {
    console.log(e);
  }
};

export const selectTeamToolboxes = (state, ids) => {
  const teamToolboxes = [];

  try {
    ids.forEach((id) => {
      teamToolboxes.push(state.dispatch.toolboxes[id]);
    });
  } catch (e) {
    console.log(e);
  }

  return teamToolboxes;
};

export const selectAllToolboxes = (state) => {
  const toolboxes = [];

  try {
    Object.keys(state.dispatch.toolboxes).forEach((key) => {
      toolboxes.push(state.dispatch.toolboxes[key]);
    });
  } catch (e) {
    console.log(e);
  }
  return toolboxes;
};

export const selectAllOccupiedToolboxes = (state) => {
  let toolboxes = [];

  try {
    Object.keys(state.dispatch.teams).forEach((key) => {
      toolboxes = toolboxes.concat(state.dispatch.teams[key].toolboxes);
    });
  } catch (e) {
    console.log(e);
  }
  return toolboxes;
};

// TEAM

export const selectTeam = (state, id) => {
  try {
    return state.dispatch.teams[id];
  } catch (e) {
    console.log(e);
  }
};

export const selectTeams = (state) => {
  const teams = [];

  try {
    Object.keys(state.dispatch.teams).forEach((key) => {
      teams.push(state.dispatch.teams[key]);
    });
  } catch (e) {
    console.log(e);
  }
  return teams;
};
